import { Node, Edge } from './types';
import { parseCoordinates } from './entityProcessor';

export interface GeographicArea {
  south: number;
  west: number;
  north: number;
  east: number;
}

// Use the real address coordinates, never the map's displaced company icons.
export function getCompaniesInArea(nodes: Node[], edges: Edge[], area: GeographicArea, date = new Date().toISOString().slice(0, 10)): Set<string> {
  const companies = new Set(nodes.filter(node => node.type === 'Company').map(node => node.id));
  const addresses = new Set(nodes.filter(node => {
    if (node.type !== 'Address') return false;
    const coords = parseCoordinates(node.properties);
    return coords !== null && coords[0] >= area.south && coords[0] <= area.north
      && coords[1] >= area.west && coords[1] <= area.east;
  }).map(node => node.id));
  const selected = new Set<string>();
  edges.forEach(edge => {
    const properties = edge.properties || {};
    if (properties.is_active === false || (properties.start_date && properties.start_date.slice(0, 10) > date)
      || (properties.end_date && properties.end_date.slice(0, 10) <= date)) return;
    if (companies.has(edge.from) && addresses.has(edge.to)) selected.add(edge.from);
    if (companies.has(edge.to) && addresses.has(edge.from)) selected.add(edge.to);
  });
  return selected;
}

// Retain direct supporting entities, but never introduce companies outside the selection.
export function getGeographicNodeIds(nodes: Node[], edges: Edge[], companyIds: ReadonlySet<string>): Set<string> {
  const types = new Map(nodes.map(node => [node.id, node.type]));
  const selected = new Set(companyIds);
  edges.forEach(edge => {
    if (companyIds.has(edge.from) && types.has(edge.to) && types.get(edge.to) !== 'Company') selected.add(edge.to);
    if (companyIds.has(edge.to) && types.has(edge.from) && types.get(edge.from) !== 'Company') selected.add(edge.from);
  });
  return selected;
}
